import './style.scss'
import { useState, useContext, useEffect } from 'react';
import utility from 'src/utils/utility'
import ApiContext from 'src/provider/API/call-service';
import { 
    AppLabel, AppSpan, AppText, Button, 
    CustomContainer, FlexColumn, 
    GridContainer, ScreenContainer 
} from 'src/style';
import ApkDownloadIcon from 'src/assets/img/apk-download.svg'
import { IAndroidBuild } from 'src/model';
import helpers from 'src/utils/helpers';
import {useTranslation} from "react-i18next";



const AppGeneration = () => {
    const {API} = useContext(ApiContext)
    const {t} = useTranslation();
    const [buildStatusInfo, setBuildStatusInfo] = useState<IAndroidBuild|null>(null)

    useEffect(() => {
        handleFetchBuildStatus()
    }, [])

    async function handleFetchBuildStatus () {
        const response = await API.fetchAndroidBuildStatus() 
        if (response) {
            setBuildStatusInfo(response)
        }
    }

    async function handleStartNewBuild () {
        const response = await API.StartAndroidBuild()
        if (response) handleFetchBuildStatus()
    }

    function handleDownload () {
        const downloadLink = document.createElement('a');
        document.body.appendChild(downloadLink);
        downloadLink.download = 'Mobile_Banking';
        downloadLink.href = buildStatusInfo?.lastBuildUrl!;
        downloadLink.click();
    }

    return (
        <ScreenContainer>
            <AppText textSize='1.9' color='#101828' fontWeight="700">
                {t('appGeneration.title')}
            </AppText>
            
            <CustomContainer 
                width='50' sizeUnit='%' topMargin='2'
                className='apk-type-block'
            >
                { !buildStatusInfo?.hasPendingBuild ?
                    <Button
                        width='100' sizeUnit='%'
                        titleSize='1.4' fontWeight='600'
                        height='4' radius='0.8'
                        bottomMargin='2.5' hoverColor='#0D968F'
                        hoverBgColor='#fff' borderColor='#0D968F'
                        onClick={handleStartNewBuild}
                    >
                        {t('appGeneration.build.startButton')}
                    </Button>
                    :
                    <FlexColumn
                        minHeight='4.7' padding='1.5'
                        radius='0.8' bgColor='#E7F6F5'
                        bottomMargin='2'
                        shadow='box-shadow: 0px 1px 2px 0px #1018280D'
                    >
                        <AppText color='#0A756F' textSize='1.2'>
                            {t('appGeneration.build.inProgress')}
                        </AppText>
                    </FlexColumn>
                }
                { buildStatusInfo?.lastBuildUrl &&
                    <GridContainer 
                        borderColor='#EAECF0' radius='0.8'
                        padding='2' minHeight='13'
                    >
                        <img src={ApkDownloadIcon} />
                        <AppText 
                            fontFamily='Montserrat' topMargin='1'
                            color='#667085' fontWeight='600'
                            align='center'
                        >
                            {t('appGeneration.build.generatedOn')} {buildStatusInfo?.lastBuildDateTime ? helpers.handleDate(buildStatusInfo?.lastBuildDateTime) : null}
                        </AppText>
                        <AppLabel 
                            color='#0A756F'
                            textSize='1.4' fontWeight='600' 
                            topMargin='1' hoverColor='#667085'
                            onClick={handleDownload}
                        >
                            {t('appGeneration.build.downloadButton')}
                        </AppLabel>
                    </GridContainer>
                }
            </CustomContainer>
        </ScreenContainer>
    )
}

export default utility.routeData('app-generation', 'App Generation', <AppGeneration/>)